import React from 'react';
import { Row, Col, Label, Button } from 'react-bootstrap';
import { unescapeHTML } from 'underscore.string';

export default class ShipmentPaneHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Row style={{paddingTop:5}}>
        <Col md={10}>
          <strong>
            {unescapeHTML(this.props.exception.shipment.shipper_name)} - {this.props.exception.shipment.shipment_id}
          </strong>
        </Col>
        <Col md={2}>
          <Button bsStyle="link" style={{float:"right"}} bsSize="xsmall" onClick={this.props.closePane}>X</Button>
        </Col>
      </Row>
    );
  }
}
